import isEmail from 'validator/lib/isEmail';
import z from 'zod';
import { ERROR_MESSAGE } from '@shared/constants/errorMessage.constant';

const emailSchema = z
  .string()
  .nonempty({ message: ERROR_MESSAGE.required })
  .refine((val: string) => isEmail(val), { message: ERROR_MESSAGE.email });

export { emailSchema };
